export const T = {
  en_GB: {
    edit: "Edit",
    title: "Cost Classes",
    description:
      "Classify products for cost mapping (e.g. brokerage class or fund type). Manual fees can target a specific class. Separate from product types (suitability).",
    noClasses: 'No product cost classes configured. Click "Add Cost Class" to create one.',
    name: "Name",
    active: "Active",
    actions: "Actions",
    className: "Cost class name",
    save: "Save",
    cancel: "Cancel",
    add: "Add",
    addClass: "Add Cost Class",
    placeholder: "e.g., Exchange-traded Nordic, Equity fund...",
    deleteClass: "Delete Cost Class",
    deleteDescription:
      "Are you sure you want to delete this cost class? This action cannot be undone.",
    delete: "Delete",
    error: "Error",
    failedToAdd: "Failed to add cost class",
    failedToUpdate: "Failed to update cost class",
    failedToDelete: "Failed to delete cost class",
  },
  nb_NO: {
    edit: "Rediger",
    title: "Kostnadsklasser",
    description:
      "Klassifiser produkter for kostnadskobling (f.eks. kurtasjeklasse eller fondstype). Manuelle kostnader kan rettes mot en bestemt klasse. Atskilt fra produkttyper (egnethet).",
    noClasses: 'Ingen produktkostnadsklasser konfigurert. Klikk "Legg til kostnadsklasse".',
    name: "Navn",
    active: "Aktiv",
    actions: "Handlinger",
    className: "Navn på kostnadsklasse",
    save: "Lagre",
    cancel: "Avbryt",
    add: "Legg til",
    addClass: "Legg til kostnadsklasse",
    placeholder: "f.eks., Børshandlet Norden, Aksjefond...",
    deleteClass: "Slett kostnadsklasse",
    deleteDescription:
      "Er du sikker på at du vil slette denne kostnadsklassen? Denne handlingen kan ikke angres.",
    delete: "Slett",
    error: "Feil",
    failedToAdd: "Kunne ikke legge til kostnadsklasse",
    failedToUpdate: "Kunne ikke oppdatere kostnadsklasse",
    failedToDelete: "Kunne ikke slette kostnadsklasse",
  },
} as const;
